import { LayoutType, withLayout } from 'hocs/with-layout';
import { ReviewVideosGuest } from './review-videos-guest';

const WrappedAccountView = withLayout(
  LayoutType.WithOldNavOnly,
  ReviewVideosGuest,
);

export { WrappedAccountView as ReviewVideosGuest };
